import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

import {
    AMERICAN_DATE_FORMAT,
    getMomentFromHippoDateString,
    TWELVE_HOUR_WITH_MERIDIEM_TIME_FORMAT
} from 'common/source/utilities/dates';

const module = angular.module('inspection-details-card', []);

interface InspectionDetailsCardController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;

    sectionTitle: string;
    sectionDescription: string;
    isExternalInspectionRequired: boolean;
    isAppointInspectionRequired: boolean;
    date: string;
    time: string;
    inspector: string;
    phone: string;
    status: string;
    subStatus: string;
    additionalInformation: string;
    isFollowUpNeeded: boolean;
}

module.component('inspectionDetailsCard', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(this: InspectionDetailsCardController) {
        function getFormattedInspectionStatus(inspection: Inspection) {
            switch (inspection.status) {
                case 'pending':
                    return 'Pending';
                case 'assigned':
                    return 'Assigned';
                case 'scheduled':
                    return 'Scheduled';
                case 'completed_review':
                case 'completed_followup':
                case 'completed':
                    return 'Completed';
            }
        }

        function getSubStatus(inspection: Inspection) {
            if (inspection.status === 'completed_review') {
                return 'Hippo review pending';
            } else if (inspection.status === 'completed_followup') {
                return 'Follow up needed';
            } else {
                return '';
            }
        }

        function getAdditionalInformation(inspection: Inspection) {
            switch (inspection.status) {
                case 'pending':
                    if (!inspection.internal) {
                        return `An exterior inspection has been ordered and should be completed soon.`;
                    } else {
                        return `An appointment based inspection has been ordered. You will be contacted by CIS
                        Inspection Services soon.`;
                    }
                case 'assigned':
                    if (!inspection.internal) {
                        return `An exterior inspection has been ordered and assigned to a field inspector and should be
                        completed soon`;
                    } else {
                        return `An appointment based inspection has been ordered and assigned to a field inspector.
                        You will be contacted by this inspector to set up a convenient time.`;
                    }
                case 'scheduled':
                    if (inspection.inspector_name) {
                        return `An appointment based inspection has been scheduled with ${inspection.inspector_name}.`;
                    } else {
                        return 'Pending';
                    }
                case 'completed_review':
                    return `The field inspector was completed and the results are pending review by the Hippo team.
                        We'll be in touch soon!`;
                case 'completed_followup':
                    return `Some issues were discovered during the inspection. A member of the Hippo team will be in
                        touch with additional details. Feel free to call us at 1-800-585-0705`;
                case 'completed':
                    return 'All is good. No additional action is needed.';
                default:
                    return '';
            }
        }

        this.$onInit = () => {
            const inspection = this.policyInfo.inspection;

            const date = getMomentFromHippoDateString(inspection.datetime);

            this.isExternalInspectionRequired = !inspection.internal;
            this.isAppointInspectionRequired = inspection.internal;
            this.time = inspection.datetime ? date.format(TWELVE_HOUR_WITH_MERIDIEM_TIME_FORMAT) : '';
            this.date = inspection.datetime ? date.format(AMERICAN_DATE_FORMAT) : '';
            this.phone = inspection.phone ? inspection.phone : 'Pending';
            this.inspector = inspection.inspector_name ? inspection.inspector_name : 'Pending';
            this.status = getFormattedInspectionStatus(inspection);
            this.subStatus = getSubStatus(inspection);
            this.isFollowUpNeeded = inspection.status === 'completed_followup';
            this.additionalInformation = getAdditionalInformation(inspection);
        };
    }
});

export { module };
